import React from 'react';
import { PaymentMethodMessagingElement } from '@stripe/react-stripe-js';
import { useCartPricing } from '../../../../contexts/CartPricingContext';
import { useLocale } from '../../../../contexts/LocaleContext';
import { isKlarnaBnplEnabled } from './klarnaBnpl';
import styles from './StripeCheckoutPage.module.scss';

/**
 * Stripe-rendered "as low as $X/mo" klarna promotional messaging for the checkout. Must render
 * inside both the Elements provider and CartPricingProvider. Renders nothing until pricing
 * resolves or when the klarna-bnpl flag is off, so the flag-off checkout is unchanged.
 */
export default function KlarnaBnplMessaging() {
  const { totalInCents } = useCartPricing();
  const { currency } = useLocale();

  if (!isKlarnaBnplEnabled(currency) || totalInCents <= 0) {
    return null;
  }

  return (
    <div className={styles.klarnaMessaging}>
      <PaymentMethodMessagingElement
        options={{
          amount: totalInCents,
          // isKlarnaBnplEnabled already restricts to usd
          currency: 'USD',
          paymentMethodTypes: ['klarna'],
          countryCode: 'US',
        }}
      />
    </div>
  );
}
